import { render, staticRenderFns } from "./OpenInvoice.vue?vue&type=template&id=9be95bde&scoped=true"
import script from "./OpenInvoice.vue?vue&type=script&lang=js"
export * from "./OpenInvoice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9be95bde",
  null
  
)

export default component.exports